import * as React from "react";
import ReactLazyLoad from "react-lazyload";
import { imageSourceGenerator } from "./image";
import { runInBrowser } from "../../utils/browser";
const dataImageRegex = /^data:image/;
export class SmartImage extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            useOriginSrc: false,
            imageSrc: "",
        };
        this.imageSourceGenerator = imageSourceGenerator(this.props.src, this.imageProps, this.fallbackSrc);
        this.updateImageSrc = (props = this.props) => {
            const { src } = props;
            if (!src || !runInBrowser()) {
                return;
            }
            if (dataImageRegex.test(src)) {
                return this.setState({ imageSrc: src });
            }
            const r = this.imageSourceGenerator.next();
            this.setState({
                useOriginSrc: r.done,
                imageSrc: r.value,
            }, () => r.done && this.finish());
        };
        this.onImageLoad = (event) => {
            try {
                if (event.target.naturalWidth <= 1) {
                    return this.onImageFailedLoad();
                }
                this.finish();
            }
            catch (err) { }
        };
        this.onImageFailedLoad = () => {
            if (!this.state.useOriginSrc) {
                this.updateImageSrc();
            }
        };
    }
    get imageProps() {
        const { qnParams, aliSize, online, keepSize } = this.props;
        return {
            qnParams,
            aliSize,
            keepSize: !!keepSize,
            online: !!online,
        };
    }
    get fallbackSrc() {
        return this.props.fallbackSrc;
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.src !== nextProps.src) {
            this.imageSourceGenerator = imageSourceGenerator(nextProps.src, this.imageProps, this.fallbackSrc);
            this.updateImageSrc(nextProps);
        }
    }
    componentDidMount() {
        this.updateImageSrc();
    }
    finish() {
        const { onFinish, src } = this.props;
        if (typeof onFinish === "function") {
            onFinish({
                originSrc: src,
                currentSrc: this.state.imageSrc,
            });
        }
    }
    render() {
        let { isLazyLoad, placeholder, imgClass, style = {}, link, linkClass, title, alt, blankLink, fit, src, } = this.props;
        src = this.state.imageSrc || src;
        let fitStyle = fit ? { objectFit: "cover", height: "100%", width: "100%" } : {};
        style = Object.assign(Object.assign({}, fitStyle), style);
        let imgProps = {
            className: imgClass,
            style,
            title,
            alt,
        };
        const placeholderEle = React.createElement("img", Object.assign({ src: placeholder }, imgProps));
        const aProps = link && blankLink ? { target: "_blank" } : {};
        if (!src) {
            return link ? (React.createElement("a", Object.assign({ href: link, className: linkClass }, aProps),
                React.createElement("img", Object.assign({ src: placeholder }, imgProps)))) : (React.createElement("img", Object.assign({ src: placeholder }, imgProps)));
        }
        let height;
        let width;
        if (style) {
            height = style.height;
            width = style.width;
        }
        let ele;
        if (isLazyLoad) {
            ele = (React.createElement(ReactLazyLoad, { height: height, placeholder: placeholderEle },
                React.createElement("img", Object.assign({ onLoad: this.onImageLoad, onError: this.onImageFailedLoad, src: src }, imgProps, { "data-load-type": "lazy" }))));
        }
        else {
            ele = (React.createElement("img", Object.assign({ src: src, onLoad: this.onImageLoad, onError: this.onImageFailedLoad }, imgProps, { width: width, height: height, "data-load-type": "normal" })));
        }
        if (link) {
            return (React.createElement("a", { href: link, className: linkClass }, ele));
        }
        return ele;
    }
}
SmartImage.defaultProps = {
    online: true,
    className: "",
    isLazyLoad: false,
    alisize: 0,
    placeholder: `https://d3hp955ol7sp5f.cloudfront.net/newhome/placeholder/ezbuy_cart_200x200.png`,
    blankLink: false,
};
export default SmartImage;
